import React, { FC } from 'react';
import { TextV2 } from 'components/TextV2/TextV2';
import styles from 'features/build-your-own/components/BYOItemTile/components/ItemFeatureDetail.module.scss';
import { BYOStepId, Feature } from 'api/contentful/contentTypes.cloverdotcom';
import { Image } from 'components/Image/Image';
import cx from 'classnames';
import { useBuildYourOwn } from 'features/build-your-own/hooks/useBuildYourOwn';
import { componentKeyV2 } from 'utils/ComponentKeyV2';
import { FlatEntry } from 'services/cms/flattenContentful';
import { useTranslation } from 'react-i18next';

interface ItemFeatureDetailProp {
  features?: FlatEntry<Feature>[];
}

export const ItemFeatureDetail: FC<ItemFeatureDetailProp> = ({ features }) => {
  const { currentStepId } = useBuildYourOwn();
  const isPosNeedsStep = BYOStepId.POS_NEEDS === currentStepId;
  const { t } = useTranslation();

  if (!features) return null;

  const iconAccessibilityText = (feature: FlatEntry<Feature>) => {
    const { icon, functionalityIncludedText, functionalityNotIncludedText } = feature;
    const isIncludedText = functionalityIncludedText
      ? functionalityIncludedText
      : t('build-your-own.icon-accessibility.functionality-included');
    const isNotIncludedText = functionalityNotIncludedText
      ? functionalityNotIncludedText
      : t('build-your-own.icon-accessibility.functionality-not-included');

    return icon ? isIncludedText : isNotIncludedText;
  };

  return (
    <>
      {features.map((feature, index) => (
        <div
          key={componentKeyV2(feature, index)}
          className={cx(styles.container, { [styles.containerUnderline]: feature.underlined })}
        >
          {feature.icon !== undefined && (
            <div className={styles.iconContainer}>
              <Image
                className={cx(feature.icon ? styles.iconIncluded : styles.iconNotIncluded)}
                aria-label={iconAccessibilityText(feature)}
              />
            </div>
          )}
          <TextV2
            isMarkdown
            variant="body"
            value={feature.blurb}
            className={cx(isPosNeedsStep ? styles.containerPosNeedsTextPadding : styles.containerText)}
          />
        </div>
      ))}
    </>
  );
};
